module.exports = __webpack_public_path__ + "img/logo_digitalbank.aba1df2f.png";